import { Button, Group, Select } from "@mantine/core";
import { useEffect, useState } from "react";
import { CategoryTree } from "@/models/categoryTree";

interface Props {
  handleDownload: (categoryTreeId: string) => void;
  categoryTrees: CategoryTree[];
  isDownloading: boolean;
}

const CategoryTreeDownloadButton: React.FC<Props> = ({ handleDownload, categoryTrees, isDownloading }) => {
  const [selectedId, setSelectedId] = useState<string>("");

  useEffect(() => {
    if (categoryTrees.length > 0) {
      setSelectedId(categoryTrees[0].id);
    }
  }, [categoryTrees]);

  const categoryOptions = categoryTrees.map(ct => ({
    value: ct.id,
    label: ct.version,
  }));

  return (
    <Group mt={3}>
      <Select
        data-testid="categoryVersion"
        placeholder="バージョン"
        allowDeselect={false}
        data={categoryOptions}
        value={selectedId}
        onChange={(value) => setSelectedId(value ?? "")}
        maxDropdownHeight={200}
        style={{ width: "10rem" }}
      />
      <Button
        data-testid="downloadButton"
        disabled={isDownloading ? true : !selectedId}
        onClick={() => handleDownload(selectedId)}
      >
        ダウンロード
      </Button>
    </Group>
  );
};

export default CategoryTreeDownloadButton;
